<template>
  <div>
    <v-row no-gutters>
      <h2>Discovery Projects</h2>
      <v-spacer></v-spacer>
      <x-button
        class="w-auto"
        color="#58e2c2"
        @click="openCreateProjectDialog"
        buttonText="Create a new project"
        v-if="
          $can('create', 'discovery_project') ||
            $can('create', 'litigation_project') ||
            $can('create', 'data_subject_request_project')
        "
        :data-test-id="`${dataTestId}__create-new-project-btn`"
      />
    </v-row>
    <v-row class="pt-7" no-gutters>
      <nested-navigation></nested-navigation>
    </v-row>
    <router-view :key="$route.path"></router-view>
    <CreateProjectDialog
      v-if="showCreateProjectDialog"
      @closeCreateProjectDialog="closeCreateProjectDialog"
    />
  </div>
</template>

<script>
import NestedNavigation from './NestedNavigation.vue';
import CreateProjectDialog from '@/components/Discovery/CreateProjectDialog';
export default {
  data() {
    return {
      showCreateProjectDialog: false,
      dataTestId: 'discovery-tool__overview'
    };
  },
  props: ['title'],
  components: {
    NestedNavigation,
    CreateProjectDialog
  },
  computed: {
    isOnboarded() {
      return this.onboardingStatus === 'ONBOARDED';
    }
  },
  methods: {
    openCreateProjectDialog() {
      if (this.isOnboarded) {
        this.showCreateProjectDialog = true;
      } else {
        this.snackbar(
          'info',
          this.$message.ACTION_RESTRICTION_WHILE_ONBOARDING
        );
      }
    },
    closeCreateProjectDialog() {
      this.showCreateProjectDialog = false;
    }
  }
};
</script>
